import { Icon } from "@iconify/react";
import React, { useState } from "react";

const Navbar = () => {
  const [showMenu, setShowMenu] = useState(false);

  const items = [
    {
      id: 1,
      nav: "about",
      name: "About",
      icon: <Icon icon="ep:info-filled" />,
    },
    {
      id: 2,
      nav: "services",
      name: "Services",
      icon: <Icon icon="fluent-mdl2:c-r-m-services" />,
    },
    {
      id: 3,
      nav: "products",
      name: "Products",
      icon: <Icon icon="icon-park-outline:ad-product" />,
    },
    {
      id: 4,
      nav: "contacts",
      name: "Contacts",
      icon: <Icon icon="mdi:contact-outline" />,
    },
  ];

  const handleScroll = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const headerOffset = 130;
      const elementPosition =
        section.getBoundingClientRect().top + window.scrollY;

      if (window.innerWidth <= 768) {
        const offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      } else {
        if (sectionId === "products") {
          const offsetPosition = elementPosition - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        } else {
          section.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }
  };

  return (
    <div className="fixed top-0 w-full h-fit p-6 bg-[#FFFFFF] shadow-md z-50">
      <div className="relative flex w-full items-center justify-between">
        <div>
          <img
            src="/images/jkmlogo.webp"
            className="w-17 h-16"
            alt="JKM Logo"
          />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-8">
          {items.map((item) => (
            <span
              key={item.id}
              className="flex items-center gap-1 text-[#002F6C] hover:text-[#D00027] focus:outline-none cursor-pointer"
              onClick={() => handleScroll(item.nav)}
            >
              {item.icon}
              {item.name}
            </span>
          ))}
        </div>

        {/* Mobile Menu Icon */}
        <Icon
          icon="stash:burger-classic"
          className="size-8 text-[#002F6C] lg:hidden"
          onClick={() => setShowMenu(!showMenu)}
        />

        {/* Mobile Menu Dropdown */}
        {showMenu && (
          <div className="absolute flex flex-col w-[60%] bg-[#F2F2F2] p-4 right-0 top-full shadow-lg rounded-lg gap-3">
            {items.map((item) => (
              <button
                key={item.id}
                className="flex items-center w-full gap-2"
                onClick={() => {
                  handleScroll(item.nav);
                  setShowMenu(false);
                }}
              >
                {item.icon}
                {item.name}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
